<template>
  <div id="at-wrapper" class="container-fluid">
    <page-header
      :page="page"
      :has-return="true"
      :left-side-class="'col-xl-8'"
      :right-side-class="
        'col-xl-4 align-items-end d-flex pb-2 justify-content-end'
      "
    >
      <template v-slot:customActions>
        <drop-down
          v-if="isMobile && isSaved && isDocumentationPending"
          title="Opciones"
          icon="fas fa-list text-green"
          :items="getActions()"
          variant="standard m-1"
          :responsive="false"
        />
        <action-button
          v-if="!isMobile && isSaved && isDocumentationPending"
          text="Descargar Referido"
          variant="outline-success m-1"
          i="fas fa-file-download"
          :responsive="false"
          @click="downloadATreport"
        />
        <action-button
          v-if="!isMobile && isSaved && isDocumentationPending"
          text="Anejar Referido"
          variant="outline-success m-1"
          i="fas fa-file-upload"
          :responsive="false"
          @click="toggleAttachSignedReferral"
        />

        <action-button
          v-if="!model.peiAtServiceStatusId"
          text="Someter"
          variant="outline-success m-1"
          i="fas fa-flag"
          :responsive="false"
          @click="submit"
        />
      </template>
    </page-header>

    <div v-if="isDocumentationPending" class="row pb-2">
      <div class="col-12">
        <CustomError
          :message="isDocumentationPendingMessage"
          variant="warning"
          :is-alert-mode="true"
        />
      </div>
    </div>

    <board v-if="isFromAtSearching" :details="referralInfo" class="mb-3" />

    <SignedReferralAttach
      v-if="showUploadFile"
      v-model="model"
      @toggleAttachSignedReferral="toggleAttachSignedReferral"
    />
    <GeneralInformation
      ref="generalInformation"
      v-model="model"
      :read-only="readOnly"
    />
    <ATEvaluationsInformation
      ref="atEvaluationsInformation"
      :read-only="readOnly"
      @canSubmit="canSubmit"
    />

    <component
      v-if="flowReady"
      :is="currentServiceComponent"
      v-model="model"
      :read-only="readOnly"
      :key="currentServiceComponent"
    />
    <div v-else class="my-3">Cargando…</div>

    <DocumentsInformation v-model="model" :read-only="readOnly" />
  </div>
</template>

<script>
import CustomError from 'custom-error';
import PageHeader from 'PageHeader';
import ActionButton from 'ActionButton';
import GeneralInformation from '@/views/pei/requestTechAssistanceServices/components/GeneralInformation';
import ATEvaluationsInformation from '@/views/pei/requestTechAssistanceServices/components/ATEvaluationsInformation';
import ServicesRequest from '@/views/pei/requestTechAssistanceServices/components/ServicesRequestInformation';
import ServicesRequestNew from '@/views/pei/requestTechAssistanceServices/components/ServicesRequestInformationNew';
import alert from 'utils/mixins/alert.mixin.js';
import DocumentsInformation from '@/views/pei/requestTechAssistanceServices/components/DocumentsInformation';
import DocumentTypes from '@/utils/constants/documentTypes';
import store from '@/store/index';
import DropDown from 'dropdown';
import {
  downloadATServiceRequest,
  getPeiAtSeviceById,
  getATSolicitorPositiions,
  getReferralTypes,
} from '@/modules/request-tech-service-assistance/api';
import documentsService from '@/services/documents';
import SignedReferralAttach from '@/views/pei/requestTechAssistanceServices/components/SignedReferralAttach';
import { peiAtServiceStatus } from '@/utils/constants/at/peiAtServiceStatus';
import router from '@/router/index';
import Board from 'Board';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';

export default {
  name: 'RequestTechAssistanceServices',
  components: {
    CustomError,
    PageHeader,
    ActionButton,
    GeneralInformation,
    ATEvaluationsInformation,
    ServicesRequest,
    ServicesRequestNew,
    DocumentsInformation,
    DropDown,
    SignedReferralAttach,
    Board,
  },
  mixins: [alert],
  data() {
    return {
      model: {
        peiATServiceId: 0,
        peiAtServiceStatusId: null,
        requestDate: new Date(),
        documents: [],
        documentType: null,
        documentFile: null,
        isDocumentTypeValid: true,
        isDocumentComplaintValid: true,
        equipmentsToCustomize: [],
        equipmentsToRepair: [],
        equipmentsToReplaceForTheft: [],
        equipmentsToReplaceForLost: [],
        equipmentsForTechAssistance: [],
        equipmentsForTrainning: [],
        hasEquipment: true,
        referralType: null,
        canSubmitEvaluation: false,
      },
      page: {
        icon: 'fas fa-desktop',
        title: 'Referido para Servicios de Asistencia Tecnológica',
        routes: [
          'Inicio',
          'PEI',
          'Referido para Servicios de Asistencia Tecnológica',
        ],
      },
      requestTechAssistanceServicesNewFlow: null,
      flowReady: false,
      showUploadFile: false,
      isDocumentationPendingMessage:
        'Para culminar con el proceso, es necesario que descargue el formulario, se firme por el solicitante y se aneje al sistema. Estos pasos los puede lograr utilizando los botones de Desargar Referido y Anejar Referido que se presentan en la parte superior izquierda de la pantalla.',
    };
  },
  computed: {
    isFromAtSearching() {
      const from = this.$route.params.from;
      return from == 'at';
    },
    isMobile() {
      return store.getters.getIsMobileDensity;
    },
    isSaved() {
      return this.model.peiATServiceId > 0;
    },
    isAnalysisPending() {
      return (
        this.model.peiAtServiceStatusId == peiAtServiceStatus.PendienteAnalisis
      );
    },
    isDocumentationPending() {
      return (
        this.model.peiAtServiceStatusId ==
        peiAtServiceStatus.PendienteDeDocumentacion
      );
    },
    readOnly() {
      return this.$route.params.id != null;
    },
    studentSie() {
      return store.getters.SelectedStudent.studentId;
    },
    referralInfo() {
      return [
        [
          {
            label: 'Número de Referido:',
            data: this.model?.referralNumber,
            icon: 'fas fa-ballot-check',
          },
          {
            label: 'Estatus:',
            data: this.model?.serviceStatusName,
            icon: 'fas fa-ballot-check',
          },
          {
            label: 'Fecha Referido:',
            data: this.$options.filters.date(this.model?.referralDate),
            icon: 'fas fa-calendar-edit',
          },
          {
            label: 'CAAT:',
            data: this.model?.caatName,
            icon: 'fas fa-ballot-check',
          },
          {
            label: 'Estudiante/Solicitante:',
            data: this.model?.selectedEvaluationDTO
              ? `${this.model?.selectedEvaluationDTO?.studentSieId} - ${this.model?.selectedEvaluationDTO?.studentName}`
              : '',
            icon: 'fas fa-address-book',
          },
        ],
      ];
    },
    currentServiceComponent() {
      return this.requestTechAssistanceServicesNewFlow
        ? 'ServicesRequestNew'
        : 'ServicesRequest';
    },
  },
  methods: {
    async submit() {
      const valid = await this.$refs.generalInformation.$refs.form.validate();
      const validEvaluations = this.$refs.atEvaluationsInformation.validateEvaluations();
      const isDocumentTypeValid = this.validateDocumentType();
      const isDocumentComplaintValid = this.validateDocumentComplaint();
      const isEquipmentValid = this.validateEquipmentsTables();

      if (!validEvaluations) {
        if (!this.canSubmitEvaluation) {
          this.ShowToast(
            '',
            'Ha transcurrido el tiempo de vida del equipo por lo que se debe realizar una revaluación mediante enmienda de PEI. De tener alguna duda favor comunicarse con el Comité Asesor de Asistencia Tecnologica (CAAT)',
            'error'
          );
          return;
        }
      }

      if (
        !valid ||
        !validEvaluations ||
        !isDocumentTypeValid ||
        !isDocumentComplaintValid ||
        !isEquipmentValid
      ) {
        this.ShowToast('Alerta', 'Información Incompleta.', 'error');
        return;
      } else {
        const formData = new FormData();
        formData.append('comments', this.model.comments);
        formData.append('cseeDirectorName', this.model.cseeDirectorName);
        formData.append('schoolDirectorName', this.model.schoolDirectorName);
        formData.append('solicitorName', this.model.solicitorName);
        formData.append('solicitorPhone', this.model.solicitorPhone);
        formData.append('solicitorPositionId', this.model.solicitorPosition.id);

        formData.append(
          'selectedEvaluationId',
          this.$refs.atEvaluationsInformation.selectedEvaluation
            .studentEvaluationId
        );

        formData.append('referralTypeId', this.model.referralType.id);

        this.model.equipmentsForTechAssistance.forEach((d) => {
          formData.append('equipmentsForTechAssistance', d);
        });

        this.model.equipmentsForTrainning.forEach((d) => {
          formData.append('equipmentsForTrainning', d);
        });

        this.model.equipmentsToCustomize.forEach((d) => {
          formData.append('equipmentsToCustomize', d);
        });

        this.model.equipmentsToRepair.forEach((d) => {
          formData.append('equipmentsToRepair', d);
        });

        this.model.equipmentsToReplaceForTheft.forEach((d) => {
          formData.append('equipmentsToReplaceForTheft', d);
        });

        this.model.equipmentsToReplaceForLost.forEach((d) => {
          formData.append('equipmentsToReplaceForLost', d);
        });

        formData.append('studentSie', Number(this.studentSie));

        formData.append(
          'minuteAtRequest',
          this.model.documents.find((x) => x.id == DocumentTypes.Minuta).file
        );
        formData.append(
          'complaintCopy',
          this.model.documents.find(
            (x) => x.id == DocumentTypes.CopiaDeQuerella
          )?.file
        );

        if (this.model.documents.some((x) => x.id == DocumentTypes.Otro)) {
          this.model.documents
            .filter((x) => x.id == DocumentTypes.Otro)
            .forEach((d) => {
              formData.append('otherFiles', d.file);
            });
        }

        this.$ApiPost('api/atservicesrequest/create', formData)
          .then((response) => {
            this.model.peiATServiceId = response.data.peiATServiceId;
            this.model.peiAtServiceStatusId = response.data.serviceStatusId;

            this.ShowToast(
              'Solicitud AT Sometida',
              'Los datos del referido de solicitud para servicios de AT fueron sometidos exitosamente.',
              'success'
            );

            this.$router.push({
              name: 'RequestTechAssistanceServices',
              params: { id: this.model.peiATServiceId },
            });
          })
          .catch((err) => {
            if (err && err.response && err.response.data) {
              this.ShowToast('Error', err.response.data.message, 'error');
            } else {
              this.ShowToast('Error', err.message, 'error');
            }
          });
      }
    },
    canSubmit(data) {
      this.canSubmitEvaluation = data;
    },
    validateEquipmentsTables() {
      let isValid = !(
        !this.model.equipmentsToCustomize.some((x) => x) &&
        !this.model.equipmentsToRepair.some((x) => x) &&
        !this.model.equipmentsToReplaceForLost.some((x) => x) &&
        !this.model.equipmentsToReplaceForTheft.some((x) => x) &&
        !this.model.equipmentsForTechAssistance.some((x) => x) &&
        !this.model.equipmentsForTrainning.some((x) => x)
      );

      if (
        this.model.referralType ||
        this.requestTechAssistanceServicesNewFlow
      ) {
        this.model.hasEquipment = isValid;
      }

      return isValid;
    },
    validateDocumentType() {
      return (this.model.isDocumentTypeValid = this.model.documents.some(
        (e) => e.id === DocumentTypes.Minuta
      ));
    },
    validateDocumentComplaint() {
      const isValid =
        this.model.equipmentsToReplaceForTheft.length === 0 ||
        (this.model.documents.some(
          (e) => e.id === DocumentTypes.CopiaDeQuerella
        ) &&
          this.model.equipmentsToReplaceForTheft.length > 0);
      return (this.model.isDocumentComplaintValid = isValid);
    },
    goBack() {
      router.push({
        name: store.getters.RedirectAtFrom,
      });
    },
    downloadATreport() {
      downloadATServiceRequest(this.model.peiATServiceId)
        .then((response) => {
          documentsService.Download(response.data);
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    getActions() {
      return [
        {
          label: 'Descargar Referido',
          icon: 'fas fa-file-download text-green pr-1',
          click: () => this.downloadATreport(),
        },
        {
          label: 'Anejar Referido',
          icon: 'fas fa-file-upload text-green pr-1',
          click: () => this.toggleAttachSignedReferral(),
        },
      ];
    },
    toggleAttachSignedReferral() {
      this.showUploadFile = !this.showUploadFile;
    },
    async getPeiAtService(id) {
      const solicitorsResponse = await getATSolicitorPositiions();
      const referralTypes = await getReferralTypes();

      const response = await getPeiAtSeviceById(id);
      const data = response.data;

      this.model = {
        ...data,
        peiATServiceId: data.peiATServiceId,
        peiAtServiceStatusId: data.serviceStatusId,
        requestDate: data.requestDate,
        referralType: referralTypes.data.find(
          (x) => x.id == data.referralTypeId
        ),
        equipmentsForTechAssistance: data.equipmentsForTechAssistance,
        equipmentsForTrainning: data.equipmentsForTrainning,
        equipmentsToCustomize: data.equipmentsToCustomize,
        equipmentsToRepair: data.equipmentsToRepair,
        equipmentsToReplaceForLost: data.equipmentsToReplaceForLost,
        equipmentsToReplaceForTheft: data.equipmentsToReplaceForTheft,
        referralNumber: data.referralNumber,
        solicitorName: data.solicitorName,
        solicitorPhone: data.solicitorPhone,
        cseeDirectorName: data.cseeDirectorName,
        solicitorPositionId: data.solicitorPositionId,
        solicitorPosition: solicitorsResponse.data.find(
          (x) => x.id == data.solicitorPositionId
        ),
        selectedEvaluation: { ...data.selectedEvaluationDTO, selected: true },
        documents: data.documents.map((d) => ({
          id: d.documentId,
          fileName: d.filename,
          file: d.content,
          type: d.documentTypeName,
        })),
        hasEquipment: true,
        isDocumentTypeValid: true,
        isDocumentComplaintValid: true,
      };

      // Set evaluation para modo lectura
      if (this.$refs.atEvaluationsInformation) {
        this.$refs.atEvaluationsInformation.evaluations = [
          this.model.selectedEvaluation,
        ];
      }
    },
  },
  async mounted() {
    const { data } = await getSysparameterByNames({
      parameterNames: ['RequestTechAssistanceServicesNewFlow'],
    });

    const flagRaw = (
      data.find((x) => x.name === 'RequestTechAssistanceServicesNewFlow')
        ?.staticValue ?? ''
    ).toString();
    this.requestTechAssistanceServicesNewFlow =
      flagRaw.toLowerCase() === 'true';

    //Si es modo lectura, carga los datos antes de mostrar el componente dinámico
    if (this.readOnly) {
      const { id } = this.$route.params;
      await this.getPeiAtService(id);
    }

    //Habilita el render del componente de servicios con el flag listo
    this.flowReady = true;
  },

  beforeRouteEnter(_, from, next) {
    next((vm) => {
      vm.$store.commit('setRedirectAtFrom', from.name);
    });
  },
};
</script>

<style scoped>
@media only screen and (max-width: 500px) {
  .header-btn {
    float: right;
  }

  #at-wrapper >>> .tag-badge-title {
    font: Bold 16px Lato;
  }

  .btn-drowpdown {
    margin-bottom: 10px;
  }

  .btn-drowpdown >>> .btn {
    color: #2db782;
  }

  #at-wrapper {
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>
